var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6649 0.33721C13.5138 0.186781 13.3242 0.0810299 13.117 0.031579C12.9099 -0.0178718 12.6931 -0.00910815 12.4906 0.0569069L0.802899 3.96514C0.586139 4.03399 0.394594 4.1657 0.252458 4.34362C0.110322 4.52154 0.0239705 4.7377 0.00430932 4.96479C-0.0153518 5.19189 0.0325595 5.41973 0.141992 5.61954C0.251425 5.81935 0.41747 5.98217 0.619156 6.08743L5.46838 8.49003L7.86503 13.3673C7.96136 13.5582 8.10877 13.7185 8.29076 13.8302C8.47276 13.942 8.68218 14.0007 8.89559 14H8.97548C9.20403 13.9831 9.42224 13.8977 9.60175 13.7549C9.78126 13.6121 9.91378 13.4184 9.98207 13.1991L13.9365 1.51448C14.0072 1.31261 14.0191 1.09478 13.971 0.886362C13.9229 0.67794 13.8168 0.487499 13.6649 0.33721ZM1.29821 5.07033L11.4999 1.65864L5.83587 7.33678L1.29821 5.07033ZM8.95151 12.7346L6.68268 8.1857L12.3468 2.50756L8.95151 12.7346Z",
    fill: "#2E2C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.ae48e1d109af822c13cf94a71f530ce5.svg";
export { ForwardRef as ReactComponent };